module.exports = __webpack_public_path__ + "img/linux_03.53ad4404.png";